var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('jade-spinner',{attrs:{"size":"small","color":"brand"}}),_c('jade-text',{attrs:{"color":"brand","weight":"semibold"}},[_vm._v(" "+_vm._s(_vm.$t('time-text', { formattedTime: _vm.formattedTime }))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }